import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import axios from '@/axios';
import global from '@/components/global.js';
import i18n from '@/locales';

import ElementUI from 'irm-ui';
import 'irm-ui/lib/theme-chalk/index.css';

import vueHashCalendar from 'vue-hash-calendar';
import 'vue-hash-calendar/lib/vue-hash-calendar.css';

// 单位适配
import '@/assets/scripts/appAdaptive';

import '@/assets/iconfont/iconfont.css';
import '@/assets/iconfont/iconfont.js';
import '@/style/main.less';

Vue.use(ElementUI, {
	i18n: (key, value) => i18n.t(key, value)
});
Vue.use(global);
Vue.use(vueHashCalendar);

Vue.use(ElementUI, {
	i18n: (key, value) => i18n.t(key, value)
});

import 'vant/lib/popup/style';
import 'vant/lib/collapse/style';
import 'vant/lib/collapse-item/style';
import 'vant/lib/search/style';
import Popup from 'vant/lib/popup';
import Collapse from 'vant/lib/collapse';
import CollapseItem from 'vant/lib/collapse-item';
import Icon from 'vant/lib/icon';
import Search from 'vant/lib/search';
Vue.use(Popup);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Icon);
Vue.use(Search);

import DialogComponent from '@/utils/modal.js';
Vue.use(DialogComponent, {
	router,
	store
});

Vue.config.productionTip = false;
Vue.prototype.$request = axios;

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app');
